.root {
  display: flex;
  flex-direction: row;
}

.justifyStart {
  justify-content: flex-start;

  & > button {
    margin-right: var(--gutter);
  }
}

.justifyEnd {
  justify-content: flex-end;

  & > button {
    margin-left: var(--gutter);
  }
}

.justifyCenter {
  justify-content: center;
}

.justifySpaceAround {
  justify-content: space-around;
}

.justifySpaceBetween {
  justify-content: space-between;
}
